import {Stack, styled} from '@mui/material';

const CustomBox = styled(Stack)`
	border-radius: 8px;
	gap: 16px;

	background-color: ${({theme}) => theme.colors.brand.primary.white};
`;

export {CustomBox};
